import { FunctionComponent, memo, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../context';
import { User } from '../../../services';
import { layoutPath } from '../../utils';

import classNames from 'classnames';
import classes from './UserMentionPreview.module.scss';

interface UserMentionPreviewProps {
  mentionedUsers: User[];
  openProfile?: boolean;
  onClick?: () => void;
  className?: string;
}

interface ClickHandlerArgs {
  event: React.MouseEvent<HTMLElement>;
  id: number;
}

export const UserMentionPreview: FunctionComponent<UserMentionPreviewProps> = memo(
  ({ mentionedUsers, openProfile, onClick, className }) => {
    const navigate = useNavigate();

    const userId = useContext(UserContext).userProfile.id;

    const onClickHandler = useCallback(
      ({ event, id }: ClickHandlerArgs) => {
        event.stopPropagation();

        if (openProfile) {
          navigate(layoutPath(`${id === userId ? '/profile' : `/profile/${id}`}`));
          return;
        }

        onClick?.();
      },
      [navigate, onClick, openProfile, userId]
    );

    if (!mentionedUsers.length) {
      return null;
    }

    const isClickable = Boolean(openProfile || onClick);

    const Tag = isClickable ? 'button' : 'div';

    return (
      <div className={classNames(classes['user-mention'], className)}>
        {mentionedUsers.map(({ id, screenName }) => {
          return (
            <Tag
              key={id}
              className={classNames(classes['user-mention__link'], {
                [classes['user-mention__link--clickable']]: isClickable,
              })}
              onClick={(event) => onClickHandler({ event, id })}
              {...(isClickable && { type: 'button' })}
            >
              @{screenName}
            </Tag>
          );
        })}
      </div>
    );
  }
);
